import AWS from "aws-sdk";

const BUCKET_NAME = "sortdesk-documents-demo";
const BUCKET_REGION = "eu-central-1";
const IDENTITY_POOL_ID = "eu-central-1:17a57000-3206-4c62-84ff-96c044bacd78";

AWS.config.update({
  region: BUCKET_REGION,
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId: IDENTITY_POOL_ID
  })
});

export const S3Service = new AWS.S3({
  apiVersion: "2006-03-01",
  params: { Bucket: BUCKET_NAME }
});

export const BuildPDFUpload = file => {
  const upload = new AWS.S3.ManagedUpload({
    params: {
      Bucket: BUCKET_NAME,
      Key: file.name,
      ContentType: "application/pdf",
      Body: file
    }
  });
  return upload;
};
